<template>
  <div class="pictureModal" :class="status">
    <button type="button" class="close p-3" aria-label="Close" @click="removeModal">
      <span aria-hidden="true">&times;</span>
    </button>

    <swiper class="swiper" :options="swiperOption">

      <swiper-slide class="background" v-for="(item, index) in pictures" :key="index"
        :style="{ backgroundImage: 'url(' + item + ')'}">
        <div class="number_text">{{index+1}} / {{pictures.length}}</div>
      </swiper-slide>

      <div class="arrow swiper-button-prev swiper-button-white" slot="button-prev"></div>
      <div class="arrow swiper-button-next swiper-button-white" slot="button-next"></div>

    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'swiper-example-loop',
  title: 'Loop mode / Infinite loop',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      message: '',
      status: 'hide',
      pictures: [
        'https://picsum.photos/600/300?random=1',
        'https://picsum.photos/600/300?random=2',
        'https://picsum.photos/600/300?random=3',
        'https://picsum.photos/600/300?random=4',
      ],
      swiperOption: {
        initialSlide: 0,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  methods: {
    removeModal() {
      this.status = 'hide';
    },
  },
  created() {
    const vm = this;
    // 自定義名稱 'pictureModal:open'
    // message: 傳入參數
    vm.$bus.$on('pictureModal:open', (message, index) => {
      this.status = 'show';
      this.pictures = message;
      console.log('index大:', index);
      // this.swiperOption.initialSlide = index;
      // console.log('this.swiperOption.initialSlide:', this.swiperOption.initialSlide);
    });
  },
};
</script>

<style lang="scss" scope>
.pictureModal{
  position: fixed;
  background-color: rgba(0, 0, 0, 0.9);
  width: 100%;
  height: 100%;
  z-index: 1100;
  .close{
    position: absolute;
    top: 0;
    right: 0;
    font-size: 2rem;
    color: #fff;
    opacity: 0.5;
    z-index: 1101;
    outline: none;
  }
  .swiper {
    height: 100%;
    .swiper-slide {
      background: no-repeat center;
      .number_text {
        color: rgb(185, 185, 185);
        border-radius: 10px;
        padding: 3px 7px;
        position: absolute;
        top: 0;
      }
    }
    .arrow{
      text-shadow: 1px 1px 5px #949494;
      outline: none;
    }
  }
}
.hide{
  visibility: hidden;
  opacity: 0;
  transition: 0.2s;
}
.show {
  visibility: visible;
  opacity: 1;
  transition: 0.2s;
}

@media screen  and (max-width: 800px){
  .pictureModal{
    .swiper {
      .swiper-slide {
        background-size: contain;
      }
    }
  }
}

</style>
